/**
 * interact.js actionChecker for editor boxes.
 *
 * interact runs its resize checker BEFORE drag: with `edges` + a 10px `margin`,
 * any press within 10px of an edge (capped at half the box size) is claimed as
 * "resize", then rejected by resize's allowFrom (.helpersResizable) — and drag
 * is never tried. Small boxes (icons, one-line text) were only grabbable at
 * their exact center. Resize is started only from the handles, so anywhere else
 * fall back to drag; interact still validates it against drag's
 * enabled/allowFrom/ignoreFrom.
 *
 * Signature matches interact's `Interactable.actionChecker(fn)`.
 */
export function boxActionChecker(pointer, event, action, interactable) {
  if (!action || action.name !== "resize") {
    return action;
  }
  const target = event && event.target;
  if (target && target.closest && target.closest(".helpersResizable")) {
    return action;
  }
  const dragOptions = (interactable && interactable.options && interactable.options.drag) || {};
  return {
    name: "drag",
    axis: dragOptions.lockAxis === "start" ? dragOptions.startAxis : dragOptions.lockAxis || "xy",
  };
}
